import { API, graphqlOperation } from 'aws-amplify'

const operation = `
    mutation UpdateTrainingResult(
        $expectedVersion: Int!
        $input: updateTrainingResultInput
        $pk: ID!
        $sk: String!
    ) {
        updateTrainingResult(
            expectedVersion: $expectedVersion
            input: $input
            pk: $pk
            sk: $sk
        ) {
            certificateType
            completedAt
            createdAt
            d1
            d2
            firstName
            lastName
            pk
            quizzesCompleted
            sk
            title {
                language
                text
            }
            updatedAt
            userType
            version
            videosCompleted
        }
    }
`

const UpdateTrainingResult = (data, onRead) =>
    API.graphql(graphqlOperation(operation, data)).then(onRead)

export default UpdateTrainingResult
